import { Injectable } from "@angular/core";

import { Observable, of } from "rxjs";
import { catchError, map, mergeMap } from "rxjs/operators";
import { Account } from "../models/account.model";
import { Login } from "../models/login";
import { AccountService } from "./account.service";
import { AuthServerProvider } from "./auth-jwt.service";

@Injectable({
    providedIn: "root",
})
export class LoginService {
    constructor(
        private authServerProvider: AuthServerProvider,
        private accountService: AccountService
    ) { }

    login(credentials: Login): Observable<Account | null> {
        return this.authServerProvider
            .login(credentials)
            .pipe(mergeMap(() => this.accountService.identity(true)));
    }

    logout(): void {
        this.authServerProvider
            .logout()
            .subscribe({
                complete: () => this.accountService.authenticate(null),
            });
    }

    loginWithSocial(credentials, callback?) {
        /* const cb = callback || function () {};
        return new Promise((resolve, reject) => {
            this.authServerProvider.loginSocial(credentials).subscribe(
                (data) => {
                    this.accountService.identity(true);
                    resolve(data);

                    return cb();
                },
                (err) => {
                    this.logout();
                    reject(err);
                    return cb(err);
                }
            );
        }); */
        return this.authServerProvider
            .loginSocial(credentials)
            .pipe(mergeMap(() => this.accountService.identity(true)));
    }
}
